// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__NNX1-","faqContainer":"FAQ_faqContainer__z1eYd","overlay":"FAQ_overlay__QVyvf","glow":"FAQ_glow__kYQPJ","groupTradingList":"FAQ_groupTradingList__dngAF"};